const getAllExportedFileInAccounting = `getAllExportedFileInAccounting`;

export default getAllExportedFileInAccounting;
